 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		53: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		53: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"7":"DeprecatedStyles","14":"EnhancedStyles","15":"app-components-Workflow-WorkflowContainer","16":"app-components-bibs-BibPage-BibPageContainer","17":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","18":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","19":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","20":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","21":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","22":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","23":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","24":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","25":"app-components-bibs-subpages-CommentPage-CommentPageContainer","26":"app-components-bibs-subpages-MarcPage-MarcPageContainer","27":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","28":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","29":"app-components-bibs-subpages-VideoPage-VideoPageContainer","30":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","31":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","32":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","33":"app-components-borrowing-fines-Fines-FinesContainer","34":"app-components-borrowing-fines-GlobalPaymentsPage","35":"app-components-borrowing-holds-Holds-HoldsContainer","36":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","37":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","38":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","39":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","40":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","41":"app-components-events-EventsSearchPage-EventsSearchPageContainer","42":"app-components-events-MyEventsPage-MyEventsPageContainer","43":"app-components-info-apps-UnregisterPage","44":"app-components-list-ListPageContainer","45":"app-components-locations-LocationsPage-LocationsPage","46":"app-components-search-Search-SearchContainer","47":"app-components-search-SearchPrintList-SearchPrintListContainer","48":"app-components-settings-account-UnregisterPage","49":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","50":"app-components-shelves-Shelf-ShelfContainer","51":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","52":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"15d5d3fafc88e8576272","1":"dcab39fcc4371b069146","2":"5567449f3ab485d1cf93","3":"66957c5917df8e481f6b","4":"0995f3587064c992b4cc","5":"ffeeac2ee173cb3ed7fd","6":"c38f232d996dd526fc47","7":"6ff9cf2d7317574e28fb","8":"3eb495eed3ac41c0c791","9":"d03ff0348c595885746a","10":"a0eeb43fc46c0c88b891","11":"7227e2b8e8a7f7c71745","12":"e95b8d87ca5a57d4c7c9","13":"2ede075dbe7afabedeae","14":"c7419ad5a811c8de4b77","15":"7bff13f621e3482bf6f8","16":"f10662b2420320cd5643","17":"e5f9e7091a4c9fd4c15a","18":"afc63c0dc3385b23821e","19":"bc6dd72d4fc11adfe6e7","20":"b4cc16d42c7eb37b08b9","21":"266fab973e2b69be3ee2","22":"14e2d2bfd9f3f91a7b2c","23":"53f81b96a8ea22e15577","24":"090df710d8257ebaa419","25":"6a2d68271d5735477778","26":"96c10ce52704a72ea005","27":"422a76328e336fc9f930","28":"c4a4d99a0701170a56fc","29":"ae446f74bb36d7b59396","30":"3ead12358ccecbe4006b","31":"0517168260ca2e656c2c","32":"d68b047de0a5b18eb1f4","33":"37e7971c3a4691d55e0f","34":"845e3216cf4735cbefbc","35":"5a43fc32c5f06e5d8502","36":"cf416a9d413bdcab1298","37":"a7efb9998b4aad4e3bd0","38":"adfca27cdabcafae3791","39":"b97c29bedccf995d57c6","40":"185902e6121ae7c006cb","41":"26f2f79ec7eba906e2df","42":"9c1bf89284f3459db568","43":"b9c55afdac634f0fe983","44":"ab3cc0588bb3536f434c","45":"cef3bca0881dd749e98a","46":"cf2b0f2c86005046c965","47":"30bc743f1bb980aeef2c","48":"47a6adb06dd16adc4802","49":"087ea8af300d5462c9c2","50":"932a2516496c0864c1e5","51":"9a9c726b92c871d92020","52":"8303a709324b7783e635","54":"e56c1d65585c82484bf2","55":"404a1ebec8b6f6ddec98","56":"6a1aa36faca463c4d847","57":"1bf8702b986a283ba86e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"54":1,"55":1,"56":1,"57":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"7":"DeprecatedStyles","14":"EnhancedStyles","15":"app-components-Workflow-WorkflowContainer","16":"app-components-bibs-BibPage-BibPageContainer","17":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","18":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","19":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","20":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","21":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","22":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","23":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","24":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","25":"app-components-bibs-subpages-CommentPage-CommentPageContainer","26":"app-components-bibs-subpages-MarcPage-MarcPageContainer","27":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","28":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","29":"app-components-bibs-subpages-VideoPage-VideoPageContainer","30":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","31":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","32":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","33":"app-components-borrowing-fines-Fines-FinesContainer","34":"app-components-borrowing-fines-GlobalPaymentsPage","35":"app-components-borrowing-holds-Holds-HoldsContainer","36":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","37":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","38":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","39":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","40":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","41":"app-components-events-EventsSearchPage-EventsSearchPageContainer","42":"app-components-events-MyEventsPage-MyEventsPageContainer","43":"app-components-info-apps-UnregisterPage","44":"app-components-list-ListPageContainer","45":"app-components-locations-LocationsPage-LocationsPage","46":"app-components-search-Search-SearchContainer","47":"app-components-search-SearchPrintList-SearchPrintListContainer","48":"app-components-settings-account-UnregisterPage","49":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","50":"app-components-shelves-Shelf-ShelfContainer","51":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","52":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"15d5d3fafc88e8576272","1":"dcab39fcc4371b069146","2":"5567449f3ab485d1cf93","3":"66957c5917df8e481f6b","4":"0995f3587064c992b4cc","5":"ffeeac2ee173cb3ed7fd","6":"c38f232d996dd526fc47","7":"6ff9cf2d7317574e28fb","8":"3eb495eed3ac41c0c791","9":"d03ff0348c595885746a","10":"a0eeb43fc46c0c88b891","11":"7227e2b8e8a7f7c71745","12":"e95b8d87ca5a57d4c7c9","13":"2ede075dbe7afabedeae","14":"c7419ad5a811c8de4b77","15":"7bff13f621e3482bf6f8","16":"f10662b2420320cd5643","17":"e5f9e7091a4c9fd4c15a","18":"afc63c0dc3385b23821e","19":"bc6dd72d4fc11adfe6e7","20":"b4cc16d42c7eb37b08b9","21":"266fab973e2b69be3ee2","22":"14e2d2bfd9f3f91a7b2c","23":"53f81b96a8ea22e15577","24":"090df710d8257ebaa419","25":"6a2d68271d5735477778","26":"96c10ce52704a72ea005","27":"422a76328e336fc9f930","28":"c4a4d99a0701170a56fc","29":"ae446f74bb36d7b59396","30":"3ead12358ccecbe4006b","31":"0517168260ca2e656c2c","32":"d68b047de0a5b18eb1f4","33":"37e7971c3a4691d55e0f","34":"845e3216cf4735cbefbc","35":"5a43fc32c5f06e5d8502","36":"cf416a9d413bdcab1298","37":"a7efb9998b4aad4e3bd0","38":"adfca27cdabcafae3791","39":"b97c29bedccf995d57c6","40":"185902e6121ae7c006cb","41":"26f2f79ec7eba906e2df","42":"9c1bf89284f3459db568","43":"b9c55afdac634f0fe983","44":"ab3cc0588bb3536f434c","45":"cef3bca0881dd749e98a","46":"cf2b0f2c86005046c965","47":"30bc743f1bb980aeef2c","48":"47a6adb06dd16adc4802","49":"087ea8af300d5462c9c2","50":"932a2516496c0864c1e5","51":"9a9c726b92c871d92020","52":"8303a709324b7783e635","54":"e56c1d65585c82484bf2","55":"404a1ebec8b6f6ddec98","56":"6a1aa36faca463c4d847","57":"1bf8702b986a283ba86e"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2290);
